import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import FeatureCardLegacy from "components/featureCard/featureCard";
import { leaderboardTagProps } from "content-ui/leaderboards/lib";
import { getDateFormattedNumeric } from "lib/utils";
import { LeaderboardPage } from "lib/types/leaderboards";
import { FullDatoImage } from "lib/types/datoBlocks";

type LeaderboardCardProps = {
  leaderboard: LeaderboardPage;
  latestId: string;
};

export const LeaderboardCard = ({
  leaderboard,
  latestId,
}: LeaderboardCardProps) => {
  const { track } = useMixpanelTracking();
  return (
    <FeatureCardLegacy
      component={"link"}
      href={
        leaderboard.publishState === "Open to application"
          ? leaderboard.applicationLink
          : leaderboard.publishState === "In review"
            ? ""
            : `/leaderboards/${leaderboard.slug}`
      }
      title={leaderboard.title}
      wrapperClasses={"h-full"}
      excerpt={leaderboard.indexDescription}
      leftLabel={
        leaderboard.showPublishDate
          ? getDateFormattedNumeric(new Date(leaderboard.publishDate).getTime())
          : undefined
      }
      rightLabel={leaderboard.editionLabel}
      backgroundImage={leaderboard.image as FullDatoImage}
      {...leaderboardTagProps(leaderboard, latestId)}
      onClick={async () => {
        await track("Leaderboard click", {
          ...leaderboard,
          Component: "Map",
        });
      }}
      sponsorInfo={leaderboard.sponsors as any}
      isSponsored={leaderboard.sponsors.length > 0}
    />
  );
};
